module.exports = __webpack_public_path__ + "img/icon-warning-jordskred-4.c90073be.svg";